import React, {useState, useEffect} from 'react';

const ControllerGroup = ({group, allController, translation, onSelectController, activeRights}) => {
    console.info(allController);
    return (
        <div className="einstellungen-box" style={{width: "30%", margin: "10px", marginBottom: "30px"}}>
            <div className="box-name">
                {group.name}
            </div>
            <div style={{overflow: "auto"}}>
                <table style={{"width": "100%"}}>
                    <tbody>
                    {group.controllerIds.map((id) => {
                        const controller = allController.find(c => c.id === id);
                        if (controller) {
                            return (
                                <tr key={id}>
                                    <td><input
                                        type={"radio"}
                                        name={"currentActiveManualTrigger"}
                                        checked={controller.manualTriggerActive === true}
                                        disabled={!(controller.enabled === true)}
                                        onClick={() => {
                                            onSelectController(id)
                                        }}
                                    /></td>

                                    {activeRights.includes('Debug.ShowIds') && (
                                        <td>{controller.id}</td>
                                    )}
                                    <td>{controller.name}</td>
                                </tr>
                            );
                        }
                    })}
                    </tbody>
                </table>
            </div>
        </div>

    )
}

export default ControllerGroup
